import { Country, State } from 'country-state-city';

/**
 * Returns all countries as { code, name } sorted alphabetically by name.
 */
export const getAllCountries = () =>
  Country.getAllCountries()
    .map((c) => ({ code: c.isoCode, name: c.name }))
    .sort((a, b) => a.name.localeCompare(b.name));

/**
 * Returns all states for a given ISO country code as { code, name }.
 * Falls back to an empty array if the country has no state data.
 * Used primarily for India (GST state list) but works for any country.
 */
export const getStatesForCountry = (countryCode) =>
  State.getStatesOfCountry(countryCode)
    .map((s) => ({ code: s.isoCode, name: s.name }))
    .sort((a, b) => a.name.localeCompare(b.name));
